import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ToolbarButton} from '../../../../../../libs/shared/ui/src/components/buttons/toolbarButton';
import {PopoverCoordinator} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {DraftMessageModel} from '../../../../../models/api/messageModel';
import {ComposerPanelId, ViewerPanelId} from '../../../../../store/panels/panelStateBase';
import {DraftAssistantDropdownContainer} from '../dropdowns/draftAssistantDropdownContainer';

/*
 * Types.
 */

export interface DraftAssistantToolbarButtonProps {
  panelId: ComposerPanelId | ViewerPanelId;
  onDraftAssistantInsertDraft: HandlerOf<string>;
  conversation: ConversationModel | null;
  message: DraftMessageModel;
}

/*
 * Component.
 */

export const DraftAssistantToolbarButton: FC<DraftAssistantToolbarButtonProps> = (props) => (
  <PopoverCoordinator
    renderButton={renderButton}
    renderModal={(modalProps) => (
      <DraftAssistantDropdownContainer
        {...modalProps}
        onDraftAssistantInsertDraft={props.onDraftAssistantInsertDraft}
        conversation={props.conversation}
        draftMessage={props.message}
      />
    )}
  />
);

function renderButton(isOpen: boolean) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <ToolbarButton
          hasHover={isOpen}
          iconName="magicWand"
          label={<Trans id="composer-draft-assistant">Compose with AI</Trans>}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
        />
      )}
    </UserThemeConsumer>
  );
}
